import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 gap-12 items-center pt-8 w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "font-semibold text-sm whitespace-nowrap" }, "Fecha de envio* ", -1)
const _hoisted_3 = { class: "col-span-2 flex flex-row gap-4 items-center" }
const _hoisted_4 = { class: "relative flex flex-row items-center gap-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row gap-4 h-full items-start pt-1" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "font-semibold text-sm whitespace-nowrap" }, "Descripción")
], -1)
const _hoisted_6 = { class: "col-span-2 rounded-md border text-sm border-gray-300 overflow-x-auto h-full p-2" }
const _hoisted_7 = { class: "flex flex-row justify-center items-center gap-4 w-full" }



import { InvestmentContractAlert } from "@/services/invest/types";

import NewModal from "@/components/atoms/NewModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowAlertModal',
  props: {
  visible: {
    type: Boolean,
    required: true,
    default: false,
  },
  alertData: {
    type: InvestmentContractAlert,
    required: true,
  },
},
  emits: ["update:visible"],
  setup(__props, { emit }) {

const props = __props;





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NewModal, {
    title: "Ver alerta de contrato",
    visible: __props.visible,
    "onUpdate:visible": _cache[1] || (_cache[1] = () => _ctx.$emit('update:visible'))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('update:visible')),
          class: "flex flex-row items-center rounded-full px-4 py-2 bg-green-700 text-sm shadow text-white disabled:bg-gray-500 transition-all"
        }, " Enviar ")
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(__props.alertData.shipmentDate
              ? new Date(__props.alertData.shipmentDate)?.toLocaleDateString("es-CL")
              : "-"), 1)
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(__props.alertData.description && __props.alertData.description != ""
            ? __props.alertData.description
            : "Sin descripción."), 1)
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})